import { ItineraryFragment } from 'generated/graphql';

type SemMonthFilterCollectorReturnType = {
  add: (itinerary: ItineraryFragment) => void;
  build: () => Set<number>;
};
const SemMonthFilterCollector = (): SemMonthFilterCollectorReturnType => {
  const availableMonths: Set<number> = new Set();
  return {
    add(itinerary: ItineraryFragment): void {
      const month = new Date(
        itinerary.legs?.[0].segments[0].sections[0].departureDate as string
      ).getMonth();
      availableMonths.add(month);
    },
    build(): Set<number> {
      return availableMonths;
    },
  };
};

export default SemMonthFilterCollector;
